import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useMediaQuery} from "@mui/material";
import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as workOrderApi from "../../api/workOrderApi/workOrderApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {EQWorkOrder, initializeWorkOrder} from "../../models/serverModels/workOrder/EQWorkOrder";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import WorkOrderForm from "./WorkOrderForm";
import WorkOrderFormMobile from "./WorkOrderFormMobile";
import {yupResolver} from "@hookform/resolvers/yup";
import {workOrderSchema} from "../../validation/workOrderSchema";

const UpdateWorkOrder = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const isMobile = useMediaQuery("(min-width: 960px)");

  const {data: workOrder, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQWorkOrder>>({
    key: ["WorkOrder", {token: tokenState, id: parseInt(id!)}],
    api: () => workOrderApi.getItem({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQWorkOrder>,
    Params.Update<EQWorkOrder>
  >({
    api: workOrderApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/workOrder");
        queryClient.invalidateQueries("workOrderList");
        queryClient.invalidateQueries("RequestedList");
      },
    },
  });

  const methods = useForm<EQWorkOrder>({
    defaultValues: workOrder?.item || initializeWorkOrder,
    resolver: yupResolver(workOrderSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(workOrder?.item);
  }, [workOrder?.item, reset]);

  const onSubmit: SubmitHandler<EQWorkOrder> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      isManual: false,
      item: {...initializeWorkOrder, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="항목 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            {isMobile ? (
              <WorkOrderForm captionColor="#546E7A" />
            ) : (
              <WorkOrderFormMobile captionColor="#546E7A" />
            )}
            <ConfirmButtonGroup link="/workOrder" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateWorkOrder;
